import { mapActions } from "vuex";

export default  {
	created () {    
	   this.updateDataPost({ 
		   data: { 
			   data: [],
			   route: 'save_factura', 
			   tablaPost: ['facturacions','diagnosticos']
			}
		}) 
	},
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'registroOrdenFtn':
							this.updateDataForm({state: 'info_ventas/fecha', data: this.dataForm[this.namePath].info_orden.fecha})
							this.updateDataForm({state: 'info_ventas/consecutivo', data: this.dataForm[this.namePath].info_orden.consecutivo})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_orden', 
									tablaPost: ['examen_diagnosticos','info_orden','info_ventas','info_examens']
								 }
							 }) 
						break;
						case 'anularExamenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'anular_examen', 
									tablaPost: ['info_examens']
								 }
							 }) 
						break;

					}
				}

				let data_backend= await this.save(event.save)

				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'registroOrdenFtn':
							this.spliceDataGet(this.indexData)
							this.updateCrud({state: 'consecutivo',data: this.consecutivo+1})
							window.open(this.url+"/api/pdf/orden_venta?id="+data_backend['ids']['id_info_orden']+"&token="+this.token, "_blank");						
							window.open(this.url+"/api/pdf/diagnosticos?id="+data_backend['ids']['id_info_examens']+"&token="+this.token, "_blank");						
						break;
						case 'anularExamenFtn':
							this.spliceDataGet(this.indexData)							
						break;
					}
				}

				await this.resetGlobal({state: 'indexData'}) 								
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
